import {
  InMemoryCache,
  IntrospectionFragmentMatcher,
  NormalizedCacheObject
} from "apollo-cache-inmemory";
import { ApolloClient } from "apollo-client";
import fetch from "isomorphic-unfetch";
import { HttpLink } from "apollo-link-http";

import { errorLink } from "./initError";
import { getLink } from "./initLink";
import introspectionQueryResultData from "./fragmentTypes";
// Polyfill fetch() on the server (used by apollo-client)
if (!process.browser) {
  global.fetch = fetch;
}

const fragmentMatcher = new IntrospectionFragmentMatcher({ introspectionQueryResultData });

interface ClientParameters {
  initialState?: NormalizedCacheObject;
  httpLinkConfig?: HttpLink.Options;
}

const getApolloClient = ({ initialState, httpLinkConfig }: ClientParameters) => {
  // Create a new client for every server-side request so that data
  // isn't shared between connections
  return new ApolloClient({
    cache: new InMemoryCache({ fragmentMatcher }).restore(initialState || {}),
    connectToDevTools: process.browser,
    link: errorLink.concat(getLink(httpLinkConfig)),
    ssrMode: !process.browser
  });
};

export { getApolloClient };
